import { TDrawResult } from '@daymade/api-contracts';
import { GameType } from '@daymade/common-lib/dbEnums';
import Separator from 'components/Separator';
import WeeklyDrawLine from 'components/WeeklyDrawLine';
import {
  isMainLotteryDraw,
  isWeeklyDraw,
} from 'components/how-it-works/GameSelector';
import { Game } from 'constants/Game';
import Link from 'next/link';
import { extendClassName, stringFromDate } from 'utils/common';
import { colors } from 'utils/constants';

interface DrawResultProps {
  result: TDrawResult;
  drawResultType?: string;
  additionalClassName?: string;
}

const Result = ({
  result,
  drawResultType,
  additionalClassName,
}: DrawResultProps) => {
  const drawResult =
    result?.draw.result && result?.draw.result.type === GameType.LOTTERY
      ? result?.draw.result
      : {
          type: GameType.LOTTERY as const,
          main: [],
          bonus: [],
        };

  return (
    <div className={extendClassName('result', additionalClassName)}>
      <div className="headerRow">
        <p>Draw date</p>
        <p>
          {result?.draw.drawDate ? stringFromDate(result?.draw.drawDate) : ''}
        </p>
      </div>

      <div
        className="separator"
        style={{
          width: '100%',
          margin: '1em 0',
        }}
      />

      <div className="entryLineContainer">
        {isMainLotteryDraw(drawResultType) && result.draw.result && (
          <>
            <WeeklyDrawLine resultOrEntryLine={drawResult} />

            {isWeeklyDraw(drawResultType) && (
              <>
                <Separator />
                {drawResult.mainAdditionalInfo &&
                drawResult.bonusAdditionalInfo ? (
                  <div className="fullWidth flexSpaceBetween">
                    <div>
                      <a
                        href={
                          drawResult.mainAdditionalInfo.verificationPageLink
                        }
                        target="_blank"
                      >
                        <em>Main number draw</em>
                      </a>
                    </div>
                    <div>
                      <a
                        href={
                          drawResult.bonusAdditionalInfo.verificationPageLink
                        }
                        target="_blank"
                      >
                        <em>Bonus number draw</em>
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="fullWidth flexCentered">
                    <a
                      href="https://www.instagram.com/daymadeuk/channel"
                      target="_blank"
                    >
                      <em>Watch live draw</em>
                    </a>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>

      <style jsx>
        {`
          a {
            text-decoration: underline;
          }

          .result {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            max-width: 500px;
            margin-top: 20px;
            background-color: white;
            border: 3px solid ${colors.primaryBrandGray}20;
            border-radius: 3px;
            padding: 2em;
            cursor: ${isWeeklyDraw(drawResultType) ? 'pointer' : 'default'};
          }

          .headerRow {
            display: flex;
            justify-content: space-between;
            padding: 0 0.1em;
          }

          .headerRow p {
            margin-bottom: 0;
            font-weight: 700;
          }

          .prizeDrawDate {
            display: flex;
            flex-direction: column;
            font-weight: bold;
          }

          .entryLineContainer {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        `}
      </style>
    </div>
  );
};

const DrawResult = ({
  result,
  drawResultType = Game.WeeklyDraw.id,
}: DrawResultProps) => {
  return (
    <>
      {isWeeklyDraw(drawResultType) && (
        <Link href={`/results/reveal?drawId=${result.draw.id}`}>
          <a className="drawResult flexCentered fullWidth">
            <Result result={result} drawResultType={drawResultType} />
          </a>
        </Link>
      )}
    </>
  );
};

export default DrawResult;
